import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CApolloError } from "app/common/CApolloError";
import { Loading } from "app/lib/components/Loading";
import { useInstrumentByIdOrNumberQuery } from "generated/generated-models";
import AccountsSummary from "./AccountsSummary";
import InstrumentHeader from "./InstrumentHeader";
const InstrumentPage = ({ instrumentNumber }) => {
    const { data, loading, error } = useInstrumentByIdOrNumberQuery({
        variables: { idOrNumber: instrumentNumber },
    });
    const instrument = data?.instrumentByIdOrNumber;
    if (loading) {
        return _jsx(Loading, {});
    }
    if (error) {
        return _jsx(CApolloError, { error: error });
    }
    return (_jsxs("section", { className: "sub-wrap", children: [_jsx(InstrumentHeader, { instrument: instrument }), _jsx(AccountsSummary, { handleOnSelectedAccount: () => {
                    return;
                }, instrument: instrument })] }));
};
export default InstrumentPage;
